// GENERATED FILE - DO NOT MODIFY
export enum MaestroBiImportExport {
    ChoiceTypeDisplayValidateInformation = "DisplayValidateInformation",
    ChoiceTypeReportAlreadyExists = "ReportAlreadyExists",
    ChoiceCreateNew = "CreateNew",
}

export let nameof = "MaestroBiImportExport";
